import React from 'react';
import styles from './Storm.module.css';
import BasePanel from '../BasePanel/BasePanel.jsx';

const stormImg = require('../../../../images/Illustration_Play_Storm.png');
const stormCanNotLoadImg = require('../../../../images/storm_can_not_load_adcopy.png');

const Storm = ({ mediaArray, videoAutoPlayInterval }) => {

    return (
        <BasePanel
            mediaArray={mediaArray}
            backgroundImage={stormImg}
            cannotLoadImage={stormCanNotLoadImg}
            customStyles={styles}
            videoAutoPlayInterval={videoAutoPlayInterval}
        />
    );
};

export default Storm;